import { render } from "./ComponenteSimulacionesHijas.vue?vue&type=template&id=0dcc5c1c&scoped=true"
import script from "./ComponenteSimulacionesHijas.vue?vue&type=script&lang=js"
export * from "./ComponenteSimulacionesHijas.vue?vue&type=script&lang=js"

import "./ComponenteSimulacionesHijas.vue?vue&type=style&index=0&id=0dcc5c1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcc5c1c"]])

export default __exports__